export const scrollToTop = () => window.scroll(0, 0)
